import {
  CHAT_ADMIN,
  CHAT_ADMIN_SETTINGS,
  CHAT_COMPLIANCE,
  CHAT_COMPLIANCE_LOG,
  CHAT_COMPLIANCE_SEARCH,
  CHATS,
} from '@constants/internal-route.constant'
import {useComplianceAccess} from '@modules/chat-compliance/useComplianceAccess'
import {usePermissions} from '@services/helper/permission.helper'
import {useT} from 'utility/useT'
import {SidebarMenuItem} from './SidebarMenuItem'
import {SidebarMenuItemWithSub} from './SidebarMenuItemWithSub'
import {ADMIN_ROUTES} from './menu-routes'

// The standard pages' navigation: the messenger (its own layout), for CHAT_ADMIN the
// administration group, and the conversation review for a company admin holding the explicit
// CHAT_COMPLIANCE grant (asked of the server: the usual gating lets every admin through).
export const SidebarMenuMain = () => {
  const t = useT()
  const {hasFeature} = usePermissions()
  const review = useComplianceAccess()

  return (
    <>
      <SidebarMenuItem gated fontIcon='bi-chat-text' to={CHATS} title={t('CHAT.MENU.CHATS')} />
      <SidebarMenuItemWithSub
        to='chat-admin-group'
        title={t('CHAT.MENU.ADMIN')}
        fontIcon='bi-sliders'
        anyOf={ADMIN_ROUTES}
        defaultOpen
      >
        <SidebarMenuItem
          gated
          fontIcon='bi-collection'
          to={CHAT_ADMIN}
          title={t('CHAT.MENU.ADMIN_CONVERSATIONS')}
          exclude={[CHAT_ADMIN_SETTINGS]}
        />
        {/* Same feature as the list (CHAT_ADMIN); the route is guarded by it too. */}
        {hasFeature(CHAT_ADMIN) && (
          <SidebarMenuItem
            fontIcon='bi-gear'
            to={CHAT_ADMIN_SETTINGS}
            title={t('CHAT.MENU.ADMIN_SETTINGS')}
          />
        )}
      </SidebarMenuItemWithSub>
      {review.allowed && (
        <>
          <SidebarMenuItem
            fontIcon='bi-shield-lock'
            to={CHAT_COMPLIANCE}
            title={t('CHAT.MENU.REVIEW')}
            exclude={[CHAT_COMPLIANCE_SEARCH, CHAT_COMPLIANCE_LOG]}
          />
          <SidebarMenuItem
            fontIcon='bi-search'
            to={CHAT_COMPLIANCE_SEARCH}
            title={t('CHAT.REVIEW.SEARCH_MESSAGES')}
          />
          <SidebarMenuItem
            fontIcon='bi-clock-history'
            to={CHAT_COMPLIANCE_LOG}
            title={t('CHAT.LOG.TITLE')}
          />
        </>
      )}
    </>
  )
}
